/* eslint-disable no-console */
import { Component, ErrorInfo,ReactNode } from 'react';

import { logger } from '../../features/logger';

type ErrorBoundaryProps = {
  children: ReactNode;
  errorCallback?: () => void;
  componentTitle?: string;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  static defaultProps: Partial<ErrorBoundaryProps> = {
    errorCallback: () => {},
    componentTitle: ''
  };

  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidMount(): void {
    const { componentTitle } = this.props;
    if (componentTitle) {
      logger.info(`${componentTitle} Screen loaded successfully.`);
    }
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    const { componentTitle, errorCallback } = this.props;

    console.log(`Error encountered on ${componentTitle} Screen`, error, errorInfo);
    logger.error(`ERROR encountered on ${componentTitle} Screen`, error.stack || error.message);

    errorCallback?.();
  }

  render(): ReactNode {
    const { children } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return <></>;
    }

    return children;
  }
}

export default ErrorBoundary;